import { PostConfiguration } from '@/types/userProperty.interface';
import { getFormattedPropertyAddress } from '@/utils/getFormattedPropertyAddress.util';
import { MapPinIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { toTitleCase } from 'utils';

export interface PropertyCardProps {
  property: PostConfiguration;
}

export const PropertyCard = (props: PropertyCardProps) => {
  const property = props.property.accountProperty;
  const propertyName = property?.name;
  const propertyAddress = getFormattedPropertyAddress(property);
  const propertyType = toTitleCase(property?.propertyType || 'None');
  const propertyBuildingId = property?.accountPropertyIngestionSource?.externalId || 'None';
  const propertyManagementCompany = property?.accountPropertyManagementCompany?.name || 'None';
  const assignedTo = props.property?.assignedTo || 'None';

  return (
    <>
      <li
        key={props.property.accountProperty.id}
        className="border-fiona-gray overflow-hidden rounded-md border bg-white px-6 py-4"
      >
        <div className="flex w-full flex-row justify-between max-md:flex-col max-md:gap-5">
          <div className="flex flex-col">
            <Link
              href={`/property/${props.property.accountProperty.id}/overview`}
              className="text-base font-bold"
            >
              {propertyName}
            </Link>
            <span className="flex flex-row gap-1">
              <MapPinIcon className="h-5 w-5" />
              <p className="text-sm text-gray-700">{propertyAddress}</p>
            </span>
          </div>
          <div className="mr-10 grid w-full grid-cols-4 gap-2 md:w-8/12">
            <p className="break-words text-sm font-light">
              <span className="text-gray-500"> Type </span>
              <br /> {propertyType}
            </p>
            <p className=" max-w-60 text-pretty break-words text-sm font-light">
              <span className="text-gray-500">Assigned to</span>
              <br /> {assignedTo}
            </p>
            <p className="break-words text-sm font-light">
              <span className="text-nowrap text-gray-500">Building ID </span>
              <br /> {propertyBuildingId}
            </p>
            <p className="break-words text-sm font-light">
              <span className="text-gray-500">Company</span>
              <br /> {propertyManagementCompany}
            </p>
          </div>
        </div>
      </li>
    </>
  );
};
